import cn from 'classnames';
import staticUrls from '@framework/url/staticUrls';
import { LogoFinsightStandart } from '@dealroadshow/uikit-logo/Finsight/Standart';
import { ColorType } from '@dealroadshow/uikit-logo/types';
import styles from './footerLogo.module.scss';

interface IProps {
  className?: string,
}

const FooterLogo = (props: IProps) => (
  <a href={ staticUrls.getUrl() }>
    <LogoFinsightStandart
      colorType={ ColorType.WHITE }
      // @ts-ignore
      className={ cn(styles.logo, { [props.className]: props.className }) }
    />
  </a>
);

export default FooterLogo;
